export default function Mensaje(code) {
  const mensajes = {
    "1": "Tu cuenta se encuentra en proceso de validación administrativa, por lo que actualmente no tienes habilitadas algunas opciones o herramientas de la plataforma, incluida la publicación de ofertas.",
    "1.1": "Si requieres más información o consideras que se trata de un error, puedes comunicarte con nuestro equipo de soporte.",
    "1.1.1": "Para recibir asistencia, contáctanos a través del siguiente correo:",
    "2": "Estamos verificando tu perfil para garantizar la seguridad de la información en la plataforma. Este proceso suele tardar solo unos minutos.",
    "2.2": "Una vez finalizada la verificación, recibirás un correo electrónico de confirmación.",
    "2.2.2": "Si consideras que se trata de un error o necesitas asistencia, puedes contactarnos a través de:",
    "3": "Estamos realizando mejoras en la plataforma para brindarte un mejor servicio. Muy pronto estaremos nuevamente disponibles.",
    "3.3": "",
    "3.3.3": "Si consideras que se trata de un error o necesitas asistencia, puedes contactarnos a través de:",
  };

  return mensajes[code];
}